import React from 'react';
import AdminDashboard from './components/AdminDashboard';
import AiCallAssistantPage from './components/AiCallAssistantPage';
import { Home, Privacy } from './rebrand/pages';
import './index.css';

// 2026 rebrand: the homepage and privacy policy use the new design (src/rebrand/).
// The pre-rebrand homepage is preserved at git tag `live-pre-rebrand-2026-09-26`;
// its components still live in src/components/ because /admin and the unlisted
// /ai-call-assistant page use them.
function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';

  if (path === '/admin') {
    return <AdminDashboard />;
  }

  // Unlisted since 2026-09-26: Primeslink leads with the AI Business Audit only.
  // Page kept reachable by direct link (old cold-email links, audit follow-ups) but
  // not linked anywhere on the site and marked noindex.
  if (path === '/ai-call-assistant') {
    return <AiCallAssistantPage />;
  }

  if (path === '/privacy-policy') {
    return <Privacy />;
  }

  return <Home />;
}

export default App;
